import { render } from "./ResetWithTokenView.vue?vue&type=template&id=dfdb54da"
import script from "./ResetWithTokenView.vue?vue&type=script&lang=js"
export * from "./ResetWithTokenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__